import Splide from '@splidejs/splide';

const QuoteSlider = () => {
    const selector = '.js--quote--slider.splide';
    const init = () => {
        const splide = new Splide(selector, {
            type   : 'slide',
            perPage: 1,
            perMove: 1,
            pagination: false,
        }).mount();

        splide.on('active', function ( SlideComponent ) {
            // replace img src attr for current quote
            const imgUrl = $(SlideComponent.slide).attr('data-picture')
            // @TODO lazyload // solve problem: wait loaded before fadeIn()
            $('.js--handle-quote-picture-on-move img').attr('src', imgUrl)
            $('.js--handle-quote-picture-on-move img').stop(true).delay(300).animate({opacity: 1}, 300);
        });

        splide.on('move', function () {
            $('.js--handle-quote-picture-on-move img').animate({opacity: 0}, 300);
        });

        splide.on('click', function () {
            splide.go('+1');
        });
    };

    if ($(selector).length > 0) {
        init();
    }

    /* return ({
        init,
    }); */
}

export default QuoteSlider;
